import { DialogActions as MuiDialogActions } from '@mui/material';
import { withStyles } from '@mui/styles';

const StepperDialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default StepperDialogActions;
